import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerActivity, isVolunteerBoardDisabledError } from './models';
import { VOLUNTEER_ACTIVITIES_KEY } from './useVolunteerActivities';

export const useVolunteerActivityQuery = ({
	id,
	enabled = true,
	impersonationContext,
}: {
	id?: string;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled: enabled && !!id,
		queryKey: [VOLUNTEER_ACTIVITIES_KEY, id, impersonationContext?.account?.id],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IVolunteerActivity>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: `volunteering/activities/${id}` }),
				'GET'
			),
		meta: {
			toastErrorMessage: (error: Error) =>
				isVolunteerBoardDisabledError(error) ? '' : 'Failed to load the volunteer activity',
		},
	});
};
